/**
 * Organisation Route
 * Redirects /org/{slug} to settings with organisation tab
 * Future: Will become full organisation management section
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/org/$slug')({
  beforeLoad: ({ params }) => {
    // Redirect to settings with organisation tab
    throw redirect({
      to: '/settings',
      search: { tab: 'organisation' },
    });
  },
});
